import { createSlice } from "@reduxjs/toolkit";
import {
  getComparePanels,
  postComparePanel,
  patchComparePanel,
  deleteComparePanel,
} from "./comparePanelAction";

const initialState = {
  list: { loading: false, error: null, items: [] },
  mutating: { loading: false, error: null },
};

const comparePanel = createSlice({
  name: "comparePanel",
  initialState,
  reducers: {
    resetComparePanelError: (state) => {
      state.list.error = null;
      state.mutating.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getComparePanels.pending, (state) => {
        state.list.loading = true;
        state.list.error = null;
      })
      .addCase(getComparePanels.fulfilled, (state, { payload }) => {
        state.list.loading = false;
        state.list.items = Array.isArray(payload) ? payload : [];
        state.list.error = null;
      })
      .addCase(getComparePanels.rejected, (state, { payload }) => {
        state.list.loading = false;
        state.list.error = payload;
      })

      .addCase(postComparePanel.pending, (state) => {
        state.mutating.loading = true;
        state.mutating.error = null;
      })
      .addCase(postComparePanel.fulfilled, (state, { payload }) => {
        state.mutating.loading = false;
        state.mutating.error = null;
        // Strip _localId before storing
        const { _localId, ...row } = payload || {};
        state.list.items = [row, ...state.list.items];
      })
      .addCase(postComparePanel.rejected, (state, { payload }) => {
        state.mutating.loading = false;
        state.mutating.error = payload;
      })

      .addCase(patchComparePanel.pending, (state) => {
        state.mutating.loading = true;
        state.mutating.error = null;
      })
      .addCase(patchComparePanel.fulfilled, (state, { payload }) => {
        state.mutating.loading = false;
        state.mutating.error = null;
        state.list.items = state.list.items.map((p) =>
          p.id === payload?.id ? payload : p
        );
      })
      .addCase(patchComparePanel.rejected, (state, { payload }) => {
        state.mutating.loading = false;
        state.mutating.error = payload;
      })

      .addCase(deleteComparePanel.pending, (state) => {
        state.mutating.loading = true;
        state.mutating.error = null;
      })
      .addCase(deleteComparePanel.fulfilled, (state, { payload }) => {
        state.mutating.loading = false;
        state.mutating.error = null;
        state.list.items = state.list.items.filter(
          (p) => p.id !== payload?.id
        );
      })
      .addCase(deleteComparePanel.rejected, (state, { payload }) => {
        state.mutating.loading = false;
        state.mutating.error = payload;
      });
  },
});

export const { resetComparePanelError } = comparePanel.actions;
export default comparePanel.reducer;
